<script setup lang="ts"></script>

<template>
  <div class="flex min-h-dvh flex-col bg-background">
    <div
      class="flex flex-1 flex-col items-center justify-center gap-8 p-4 sm:gap-14 sm:p-6"
    >
      <AppBrand width="250" />
      <slot />
    </div>
    <AuthFooter />
  </div>
</template>

<style scoped></style>
